import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJDropboxSuccessModal from "../view/FJDropboxSuccessModal";
import FJLocalStore from "../../../store/FJLocalStore";
import FJMessageStore from "../../../store/FJMessageStore";
import {FJExportVideoAction, FJModalAction} from "../../../redux/action/FJRoot.action";

class FJDropboxSuccessModalContainer extends Component {

  _onCopy = () => {
    FJMessageStore.addMessage(FJLocalStore._('copy-successful'));
  };

  render() {
    const {visible, projectName, dropBoxShareUrl, cancelShareDropbox, hideDropboxSuccessModal} = this.props;
    return (
      <FJCommonModal visible={visible}
                     onCancel={hideDropboxSuccessModal}
                     onHide={cancelShareDropbox}
                     hasOuterCloseBtn
      >
        <FJDropboxSuccessModal title={FJLocalStore._('upload-success-title')}
                               visible={visible}
                               videoText={FJLocalStore._('video-name')}
                               shareText={FJLocalStore._('share-link')}
                               copyText={FJLocalStore._('copy')}
                               sociaText={FJLocalStore._('social-media')}
                               designTitle={projectName}
                               shareUrl={dropBoxShareUrl}
                               onCopy={this._onCopy}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowDropboxSuccessModal,
    dropBoxShareUrl: state.modal.dropBoxShareUrl,
    projectName: state.user.projectName,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    cancelShareDropbox: function () {
      dispatch(FJExportVideoAction.cancelShareDropboxAction());
    },
    hideDropboxSuccessModal: function () {
      dispatch(FJModalAction.setIsShowDropboxSuccessModalAction(false));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJDropboxSuccessModalContainer);
